<!--
 * @Description: 首页组件
 -->
<template>
  <div class="home-wrapper">
    <!-- 顶部轮播图区域 -->
    <div class="hero-section">
      <div class="hero-container">
        <!-- 左侧分类导航 -->
        <div class="category-wrapper">
          <div class="category-nav">
            <div class="category-header">
              <i class="el-icon-menu"></i>
              <span>商品分类</span>
            </div>
            <ul class="category-list">
              <li
                class="category-item"
                v-for="(type, k) in typeArray"
                :key="k"
                @mouseenter="showSubType(type)"
              >
                <i class="el-icon-goods"></i>
                <span>{{ type.name }}</span>
                <i class="el-icon-arrow-right arrow"></i>
              </li>
            </ul>
          </div>
          <!-- 子分类悬浮框 - 放在外面避免被裁剪 -->
          <div
            class="sub-category"
            v-show="showSubTypeList"
            @mouseenter="showSubTypeList = true"
            @mouseleave="hiddenSubType"
          >
            <div class="sub-category-title">{{hoverType.name}}</div>
            <div class="sub-category-content">
              <router-link
                :to="'goods?type=' + child.id + '&type_text=' + child.name"
                target="_blank"
                class="sub-category-link"
                v-for="(child, i) in subTypeList"
                :key="i"
              >
                {{ child.name }}
              </router-link>
            </div>
          </div>
        </div>

        <!-- 中间轮播图 -->
        <div class="carousel-wrapper">
          <el-carousel height="420px" :interval="5000" indicator-position="none" arrow="always">
            <el-carousel-item v-for="item in carousel" :key="item.carousel_id">
              <div class="carousel-item-wrapper">
                <img
                  v-if="item.type === 1 || item.type >= 3"
                  :src="item.image"
                  :alt="item.title"
                  class="carousel-image"
                  @click="redirectDiffPage(item)"
                />
                <video-player
                  v-else-if="item.type === 2"
                  id="videoPlayer"
                  class="video-player vjs-custom-skin"
                  ref="videoPlayer"
                  :playsinline="true"
                  :options="videoOptions[item.id]"
                >
                </video-player>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>

        <!-- 右侧快捷入口 -->
        <div class="quick-entry">
          <div class="quick-entry-header">
            <span class="user-greeting">热门商家</span>
          </div>
          <div class="quick-links">
            <router-link :to="{ path: '/shop', query: { SID: 30 } }" target="_blank" class="quick-link">
              <div class="quick-link-icon">
                <img src="@/assets/imgs/f1.png" alt="供应商1" />
              </div>
              <span>宝宝熊玩具</span>
            </router-link>
            <router-link :to="{ path: '/shop', query: { SID: 8 } }" target="_blank" class="quick-link">
              <div class="quick-link-icon">
                <img src="@/assets/imgs/f2.png" alt="供应商2" />
              </div>
              <span>毛豆米子</span>
            </router-link>
            <router-link :to="{ path: '/shop', query: { SID: 112 } }" target="_blank" class="quick-link">
              <div class="quick-link-icon">
                <img src="@/assets/imgs/f3.png" alt="供应商3" />
              </div>
              <span>易乐玩具</span>
            </router-link>
            <router-link :to="{ path: '/shop', query: { SID: 1177 } }" target="_blank" class="quick-link">
              <div class="quick-link-icon">
                <img src="@/assets/imgs/f4.png" alt="供应商4" />
              </div>
              <span>长青玩具</span>
            </router-link>
            <router-link :to="{ path: '/shop', query: { SID: 1468 } }" target="_blank" class="quick-link">
              <div class="quick-link-icon">
                <img src="@/assets/imgs/f5.jpg" alt="供应商5" />
              </div>
              <span>海婷家居</span>
            </router-link>
            <router-link :to="{ path: '/shop', query: { SID: 1595 } }" target="_blank" class="quick-link">
              <div class="quick-link-icon">
                <img src="@/assets/imgs/f6.jpg" alt="供应商6" />
              </div>
              <span>毛绒之家</span>
            </router-link>
          </div>
        </div>
      </div>
    </div>

    <!-- 主要内容区域 -->
    <div class="main-content">
      <div class="container">
        <!-- 品牌商家区域 -->
        <section class="section brand-section">
          <div class="section-header">
            <div class="section-title">
              <i class="el-icon-s-shop"></i>
              <span>品牌商家</span>
            </div>
            <div class="section-desc">绒博汇最全商家，最新毛绒玩具批发火爆热销中</div>
            <router-link to="goods" target="_blank" class="section-more">
              更多 <i class="el-icon-arrow-right"></i>
            </router-link>
          </div>
          <div class="brand-content">
            <div class="brand-sidebar">
              <ul class="brand-list">
                <li
                  v-for="(item, key) in shops"
                  :key="key"
                  @mouseenter="switchShopGoods(item.sp_id)"
                  :class="['brand-item', { active: item.sp_id == hoverShopId }]"
                >
                  <router-link :to="{ path: '/shop', query: { SID: item.sp_id } }" target="_blank">
                    {{ item.title }}
                  </router-link>
                </li>
              </ul>
            </div>
            <div class="brand-goods" v-loading="loading" element-loading-text="加载中...">
              <div class="goods-showcase">
                <div class="showcase-main">
                  <router-link
                    :to="{ path: '/detail', query: { id: shopGoods[0] ? shopGoods[0].id : 0 } }"
                    target="_blank"
                    class="main-product"
                  >
                    <img :src="shopGoods[0] ? shopGoods[0].image : ''" alt="主推商品" />
                    <div class="product-tag">热卖</div>
                  </router-link>
                </div>
                <div class="showcase-grid">
                  <router-link
                    v-for="(item, index) in shopGoods.slice(1, 5)"
                    :key="index"
                    :to="{ path: '/detail', query: { id: item ? item.id : 0 } }"
                    target="_blank"
                    class="grid-product"
                  >
                    <img :src="item ? item.Picture : ''" :alt="item ? item.name : ''" />
                    <div class="product-name">{{ item ? item.name : '' }}</div>
                  </router-link>
                </div>
              </div>
              <div class="goods-list-row">
                <router-link
                  v-for="(item, index) in shopGoods.slice(5, 10)"
                  :key="index"
                  :to="{ path: '/detail', query: { id: item ? item.id : 0 } }"
                  target="_blank"
                  class="list-product"
                >
                  <img :src="item ? item.Picture : ''" :alt="item ? item.name : ''" />
                  <div class="product-name">{{ item ? item.name : '' }}</div>
                </router-link>
              </div>
            </div>
          </div>
        </section>

        <!-- 热门短视频区域 -->
        <section class="section video-section">
          <div class="section-header">
            <div class="section-title">
              <i class="el-icon-video-camera"></i>
              <span>热门短视频</span>
            </div>
            <div class="section-desc">绒博汇热播毛绒玩具短视频，最火爆的毛绒玩具批发短视频专区</div>
            <router-link to="goods" target="_blank" class="section-more">
              更多 <i class="el-icon-arrow-right"></i>
            </router-link>
          </div>
          <div class="video-content">
            <div class="video-main">
              <video-player
                id="videoPlayer"
                class="video-player vjs-custom-skin"
                ref="videoPlayer"
                :playsinline="true"
                :options="videoGoodOption"
              >
              </video-player>
              <div class="video-info-overlay">
                <div class="shop-card">
                  <router-link :to="{ path: '/shop', query: { SID: playedItem.SID } }" target="_blank">
                    <div class="shop-card-title">进店逛逛</div>
                  </router-link>
                  <div class="shop-card-name">{{ playedItem.SName }}</div>
                  <div class="shop-card-address">{{ playedItem.Addr }}</div>
                </div>
              </div>
            </div>
            <div class="video-list">
              <div
                v-for="(item, index) in videoGoods.slice(1, 6)"
                :key="index"
                class="video-item"
                @click="playVideo(item)"
              >
                <div class="video-cover-wrapper">
                  <img :src="item ? item.cover : ''" class="video-cover" />
                  <div class="video-play-btn" v-if="playedVideoId !== item.ID">
                    <i class="el-icon-video-play"></i>
                  </div>
                  <div class="video-play-btn playing" v-else>
                    <i class="el-icon-video-pause"></i>
                  </div>
                </div>
                <router-link
                  :to="{ path: '/detail', query: { id: videoGoods[index + 1].PID } }"
                  target="_blank"
                  class="video-details"
                >
                  <div class="video-title">{{ videoGoods[index + 1].PName }}</div>
                  <div class="video-stats">{{ videoGoods[index + 1].PHotNum }}次播放</div>
                </router-link>
              </div>
            </div>
          </div>
        </section>

        <!-- 精选单品区域 -->
        <section class="section product-section">
          <div class="section-header">
            <div class="section-title">
              <i class="el-icon-star-on"></i>
              <span>精选单品</span>
            </div>
            <div class="section-desc">绒博汇精选毛绒玩具公仔、儿童玩具、创意抱枕、等身抱枕、沙发靠垫、汽车坐垫</div>
            <router-link to="goods" target="_blank" class="section-more">
              更多 <i class="el-icon-arrow-right"></i>
            </router-link>
          </div>
          <GoodsList :list="allRecGoods" v-if="allRecGoods.length > 0" class="products-grid"></GoodsList>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import type from "../assets/json/type.json";
import VideoPlayer from "vue-video-player";
import "video.js/dist/video-js.css";
import GoodsList from "../components/GoodsList.vue";

Vue.use(VideoPlayer);

// 重写localStorage原型，设置缓存时间
Storage.prototype.setExpire = (key, value, expire) => {
  let obj = {
    data: value,
    time: Date.now(),
    expire: expire,
  };
  //localStorage 设置的值不能为对象,转为json字符串
  localStorage.setItem(key, JSON.stringify(obj));
};

// 重写localStorage原型，获取定时缓存
Storage.prototype.getExpire = (key) => {
  let val = localStorage.getItem(key);
  if (!val) {
    return val;
  }
  val = JSON.parse(val);
  if (Date.now() - val.time > val.expire) {
    localStorage.removeItem(key);
    return null;
  }
  return val.data;
};

export default {
  name: "Home",
  data() {
    return {
      loading: true,
      videoOptions: [{}],
      typeArray: type,
      hoverType: {},
      subTypeList: [],
      showSubTypeList: false,
      carousel: [],
      shops: [],
      hoverShopId: 0,
      shopGoods: [],
      videoGoods: [],
      videoGoodOption: {},
      playedVideoId: 0,
      playedItem: { SID: 1, SName: "", Addr: "" },
      playedVideoPoster: "",
      allRecGoods: [], // 推荐商品数据
    };
  },
  created() {
    this.initHomeData();
    // 初始化视频列表
    this.setVideoGoods();
    this.setAllRecGoods();
  },
  methods: {
    /**
     * 获取首页数据(添加限时缓存)
     */
    async initHomeData() {
      const response = await this.$axios.post(
        this.$apiBaseUrl + "/api/617f9ae78669e",
        { website: 1 }
      );
      const homeAds = response.data.data;
      this.carousel = homeAds.banner;
      // 视频播放器初始化
      for (let item of this.carousel) {
        if (item.type === 2) {
          this.videoOptions[item.id] = {
            autoplay: true,
            loop: true,
            preload: "auto",
            // language: "zh-CN", // 语言，'en', 'zh-cn', 'zh-tw'
            aspectRatio: "16:9",
            fluid: true,
            notSupportedMessage: "此视频暂无法播放，请稍后再试",
            controlBar: {
              timeDivider: true,
              durationDisplay: true,
              fullscreenToggle: true, // 是否显示全屏按钮
            },
            sources: [
              {
                type: "video/mp4",
                src: item.video,
              },
            ],
            poster: item.image,
          };
        }
      }
      // 设置品牌商家
      this.shops = homeAds.supply.sort(() => Math.random() - 0.5);
      if (this.shops[0]) {
        this.switchShopGoods(this.shops[0].sp_id);
      }
      this.loading = false;
    },
    /**
     * 获取视频列表(添加限时缓存)
     */
    async setVideoGoods() {
      if (!localStorage.getExpire("homeVideos")) {
        const response = await this.$axios.post(
          this.$apiBaseUrl + "/api/62749b1d2195c"
        );
        localStorage.setExpire(
          "homeVideos",
          JSON.stringify(response.data.data),
          1000 * 3600
        );
      }
      this.videoGoods = JSON.parse(localStorage.getExpire("homeVideos"));
      const item = this.videoGoods[0];
      this.playedItem = item;
      this.playedVideoPoster = item.cover;
      this.videoGoodOption = {
        autoplay: false,
        loop: true,
        preload: "auto",
        language: "zh-CN",
        aspectRatio: "16:9",
        fluid: true,
        notSupportedMessage: "此视频暂无法播放，请稍后再试",
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          fullscreenToggle: true, // 是否显示全屏按钮
        },
        sources: [
          {
            type: "video/mp4",
            src: item.video,
          },
        ],
        poster: item.cover,
      };
    },
    /**
     * 查看子类别
     * @param type
     */
    showSubType(type) {
      this.hoverType = type;
      this.subTypeList = type.child;
      this.showSubTypeList = true;
    },
    /**
     * 隐藏子类别
     */
    hiddenSubType() {
      this.subTypeList = [];
      this.showSubTypeList = false;
    },
    /**
     * 轮播图重定向
     * @param {*} page
     */
    redirectDiffPage(page) {
      if (page) {
        // 外链跳转
        if (page.type === 3 && page.url) {
          window.open(page.url, "_blank");
        }
        // 商家跳转
        if (page.sp_id) {
          const routerUrl = this.$router.resolve({ path: '/shop', query: { SID: page.sp_id } })
          window.open(routerUrl.href, "_blank");
        }
      }
    },
    /**
     * 品牌商家商品切换
     * 加入缓存storage?
     * @param {*} shopId
     */
    async switchShopGoods(shopId) {
      this.loading = true;
      this.hoverShopId = shopId;
      const { data } = await this.$axios.post(
        this.$newApi + "/api/rbh/goods/list",
        { cache: 1, SID: shopId }
      );
      if (data) {
        const shopGoodsData = data.data.list.slice(0, 10);
        this.shopGoods = this.formatGoods(shopGoodsData);
      }
      this.loading = false;
    },
    /**
     * 播放视频
     * @param {*} item
     */
    playVideo(item) {
      this.playedVideoId = item.ID;
      this.playedItem = item;
      this.playedVideoPoster = item.cover;
      this.videoGoodOption = {
        autoplay: true,
        loop: true,
        preload: "auto",
        language: "zh-CN",
        aspectRatio: "16:9",
        fluid: true,
        notSupportedMessage: "此视频暂无法播放，请稍后再试",
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          fullscreenToggle: true, // 是否显示全屏按钮
        },
        sources: [
          {
            type: "video/mp4",
            src: item.video,
          },
        ],
        poster: item.cover,
      };
    },
    /**
     * 格式化品牌商家商品数组
     * @param {*} goods
     */
    formatGoods(goods) {
      let newA = [];
      for (let item of goods) {
        let imageUrl = "";
        if (item) {
          imageUrl = item.Picture;
          imageUrl = imageUrl.replace("UpLoad", "EnPic");
          imageUrl = imageUrl.substring(0, imageUrl.lastIndexOf(".")) + ".dat";
        }
        newA.push({
          id: item ? item.ID : 0,
          image: imageUrl,
          Picture: item.Picture,
          skuFlag: item ? item.skuFlag : 0,
          name: item ? item.PName : "",
        });
      }
      return newA;
    },
    /**
     * 获取所有商品(添加限时缓存)
     */
    async setAllRecGoods() {
      if (!localStorage.getExpire("allGoods")) {
        const { data } = await this.$axios.get(
          this.$newApi + "/api/rbh/goods/type?area_id=1&type=1"
        );
        localStorage.setExpire(
          "allGoods",
          JSON.stringify(data.data.list),
          1000 * 300
        );
      }
      this.allRecGoods = JSON.parse(localStorage.getExpire("allGoods"));
    },
    /**
     * 跳转商品详情
     * @param {*} id
     */
    showDetail(id) {
      this.$router.push("/detail?id=" + id);
    },
  },
  components: { GoodsList },
};
</script>

<style scoped>
@import "../assets/css/index.css";

/* 首页整体包装 */
.home-wrapper {
  width: 100%;
  background: #f5f7fa;
  min-height: 100vh;
}

/* 顶部英雄区域 */
.hero-section {
  background: linear-gradient(135deg, #fff5f5 0%, #fff 50%, #f0f7ff 100%);
  padding: 20px 0;
}

.hero-container {
  width: 1240px;
  margin: 0 auto;
  display: flex;
  gap: 15px;
}

/* 分类导航容器 */
.category-wrapper {
  position: relative;
  z-index: 1000;
}

/* 分类导航 */
.category-nav {
  width: 220px;
  background: linear-gradient(180deg, #2d3436 0%, #1a1a2e 100%);
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
}

.category-header {
  background: linear-gradient(135deg, #ff6b6b 0%, #ee5a5a 100%);
  color: white;
  padding: 14px 20px;
  font-size: 16px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 10px;
}

.category-list {
  list-style: none;
  padding: 8px 0;
  margin: 0;
}

.category-item {
  padding: 8px 20px;
  color: rgba(255, 255, 255, 0.9);
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 14px;
}

.category-item:hover {
  background: linear-gradient(90deg, rgba(255, 107, 107, 0.9) 0%, rgba(255, 107, 107, 0.7) 100%);
  padding-left: 25px;
}

.category-item .arrow {
  margin-left: auto;
  font-size: 12px;
  opacity: 0.6;
}

/* 子分类悬浮框 */
.sub-category {
  position: absolute;
  left: 100%;
  top: 50px;
  width: 350px;
  height: 325px;
  background: rgba(255, 255, 255, 0.85);
  backdrop-filter: blur(10px);
  border-radius: 12px;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.15);
  z-index: 1001;
  padding: 20px;
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;
}

.sub-category-title {
  font-size: 16px;
  font-weight: 600;
  color: #333;
  margin-bottom: 15px;
  padding-bottom: 10px;
  border-bottom: 2px solid #ff6b6b;
}

.sub-category-content {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.sub-category-link {
  padding: 8px 16px;
  background: #f8f9fa;
  border-radius: 20px;
  color: #555;
  font-size: 13px;
  transition: all 0.3s ease;
  text-decoration: none;
}

.sub-category-link:hover {
  background: linear-gradient(135deg, #ff6b6b 0%, #ee5a5a 100%);
  color: white;
  transform: translateY(-2px);
}

/* 轮播图区域 */
.carousel-wrapper {
  flex: 1;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
}

.carousel-item-wrapper {
  width: 100%;
  height: 100%;
}

.carousel-image {
  width: 100%;
  height: 100%;
  /* object-fit: cover; */
  cursor: pointer;
  transition: transform 0.5s ease;
}

.carousel-image:hover {
  transform: scale(1.02);
}

/* 右侧快捷入口 */
.quick-entry {
  width: 200px;
  background: white;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
}

.quick-entry-header {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 15px;
  text-align: center;
}

.user-greeting {
  color: white;
  font-size: 14px;
  font-weight: 500;
}

.quick-links {
  padding: 15px;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  justify-content: center;
}

.quick-link {
  width: 80px;
  text-align: center;
  text-decoration: none;
  transition: transform 0.3s ease;
}

.quick-link:hover {
  transform: translateY(-3px);
}

.quick-link-icon {
  width: 70px;
  height: 70px;
  border-radius: 12px;
  overflow: hidden;
  margin-bottom: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.quick-link-icon img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.quick-link span {
  font-size: 12px;
  color: #666;
}

/* 主要内容区域 */
.main-content {
  padding: 30px 0;
}

.container {
  width: 1240px;
  margin: 0 auto;
}

/* 通用区块样式 */
.section {
  background: white;
  border-radius: 16px;
  padding: 24px;
  margin-bottom: 24px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
}

.section-header {
  display: flex;
  align-items: center;
  padding-bottom: 20px;
  border-bottom: 1px solid #f0f0f0;
  margin-bottom: 20px;
}

.section-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 20px;
  font-weight: 600;
  color: #333;
}

.section-title i {
  color: #ff6b6b;
  font-size: 22px;
}

.section-desc {
  flex: 1;
  margin: 0 20px;
  font-size: 14px;
  color: #999;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.section-more {
  color: #ff6b6b;
  font-size: 14px;
  text-decoration: none;
  display: flex;
  align-items: center;
  gap: 4px;
  transition: all 0.3s ease;
}

.section-more:hover {
  color: #ee5a5a;
  gap: 8px;
}

/* 品牌商家内容 */
.brand-content {
  display: flex;
  gap: 15px;
}

.brand-sidebar {
  width: 160px;
  flex-shrink: 0;
}

.brand-list {
  list-style: none;
  padding: 0;
  margin: 0;
  max-height: 480px;
  overflow-y: auto;
}

.brand-list::-webkit-scrollbar {
  width: 4px;
}

.brand-list::-webkit-scrollbar-thumb {
  background: #ff6b6b;
  border-radius: 2px;
}

.brand-item {
  margin-bottom: 8px;
  border-radius: 8px;
  overflow: hidden;
}

.brand-item a {
  display: block;
  padding: 10px 12px;
  color: #555;
  font-size: 13px;
  text-decoration: none;
  text-align: center;
  background: #f8f9fa;
  border-radius: 8px;
  transition: all 0.3s ease;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.brand-item:hover a,
.brand-item.active a {
  background: linear-gradient(135deg, #ff6b6b 0%, #ee5a5a 100%);
  color: white;
  font-weight: 500;
}

.brand-goods {
  flex: 1;
  min-width: 0;
}

.goods-showcase {
  display: flex;
  gap: 15px;
  margin-bottom: 15px;
}

.showcase-main {
  width: 58%;
}

.main-product {
  display: block;
  width: 100%;
  height: 280px;
  border-radius: 12px;
  overflow: hidden;
  position: relative;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
}

.main-product img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.5s ease;
}

.main-product:hover img {
  transform: scale(1.05);
}

.product-tag {
  position: absolute;
  top: 15px;
  left: 15px;
  background: linear-gradient(135deg, #ff6b6b 0%, #ee5a5a 100%);
  color: white;
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 500;
}

.showcase-grid {
  width: 42%;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.grid-product {
  width: calc(50% - 5px);
  height: 135px;
  border-radius: 10px;
  overflow: hidden;
  position: relative;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
}

.grid-product:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
}

.grid-product img {
  width: 100%;
  height: 100px;
  object-fit: cover;
}

.grid-product .product-name {
  padding: 8px;
  font-size: 12px;
  color: #333;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  background: #f9f9f9;
}

.goods-list-row {
  display: flex;
  gap: 10px;
}

.list-product {
  flex: 1;
  min-width: 0;
  height: 160px;
  border-radius: 10px;
  overflow: hidden;
  position: relative;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
}

.list-product:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
}

.list-product img {
  width: 100%;
  height: 120px;
  object-fit: cover;
}

.list-product .product-name {
  padding: 8px;
  font-size: 12px;
  color: #333;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  background: #f9f9f9;
}

/* 视频区域 */
.video-content {
  display: flex;
  gap: 20px;
}

.video-main {
  width: 65%;
  position: relative;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
}

.video-main .video-player {
  width: 100%;
}

.video-info-overlay {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: linear-gradient(transparent, rgba(0, 0, 0, 0.8));
  padding: 60px 20px 20px;
}

.shop-card {
  text-align: center;
  color: white;
}

.shop-card-title {
  display: inline-block;
  background: #ff6b6b;
  padding: 6px 20px;
  border-radius: 20px;
  font-size: 13px;
  margin-bottom: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.shop-card-title:hover {
  background: #ee5a5a;
  transform: scale(1.05);
}

.shop-card a {
  text-decoration: none;
  color: inherit;
}

.shop-card-name {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 4px;
}

.shop-card-address {
  font-size: 12px;
  opacity: 0.8;
}

.video-list {
  width: 35%;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.video-item {
  display: flex;
  gap: 12px;
  padding: 10px;
  background: #f8f9fa;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.video-item:hover {
  background: #fff0f0;
  transform: translateX(4px);
}

.video-cover-wrapper {
  width: 120px;
  height: 80px;
  border-radius: 8px;
  overflow: hidden;
  position: relative;
  flex-shrink: 0;
}

.video-cover {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.video-play-btn {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 36px;
  height: 36px;
  background: rgba(255, 107, 107, 0.9);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 18px;
  transition: all 0.3s ease;
}

.video-play-btn:hover {
  background: #ff6b6b;
  transform: translate(-50%, -50%) scale(1.1);
}

.video-play-btn.playing {
  background: rgba(102, 126, 234, 0.9);
}

.video-details {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-decoration: none;
}

.video-title {
  font-size: 13px;
  color: #333;
  margin-bottom: 6px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  line-clamp: 2;
}

.video-stats {
  font-size: 12px;
  color: #999;
}

/* 精选单品区域 */
.products-grid {
  margin-top: 10px;
}

/* 响应式调整 */
@media (max-width: 1260px) {
  .hero-container,
  .container {
    width: 100%;
    padding: 0 10px;
    box-sizing: border-box;
  }
}
</style>
